<script>


import {vMaska} from "maska";

//TODO check quantity no negative value allowed

export default {

  name: 'RegInvoice',
  directives: {maska: vMaska},
  data() {
    return {
      selectedProviderName: '',
      selectedProductName: '',
      selectedLocationName: '',
      locations: '',
      providers: '',
      products: '',
      invoiceDetail: {
        invoice: 0,
        product: 0,
        quantity: 0,
        unitCost: 0,
        grossCost: 0,
        netCost: 0,
        taxes: 0,
        taxesPercentage: 0,
        itemBatch: '',
        barcode: '',
        expires: "0000-01-01",
      },
      invoice: {
        id: 0,
        usr: 0,
        provider: 0,
        code: '',
        grossCost: 0,
        taxes: 0,
        netCost: 0,
        createdAt: "0000-01-01T01:01:01-06:00",
        f01: '',
        invoiceDate: '',
        purchaseOrder: '',
        location: 0,
      },
      invoiceDetails: [],
    };
  },
  methods: {
    applyMask() {
      let value = this.invoice.purchaseOrder;

      // Remove non-alphanumeric characters
      value = value.replace(/[^a-zA-Z0-9]/g, '');

      // Define mask patterns

      const maxPattern1Length = 12; // CM-SDE-000-0000 (12 alphanumeric characters without hyphens)
      const maxPattern2Length = 13; // 123-4-5-6789-1122 (13 digits without hyphens)

      if (value.substring(0, 1).match(/[0-9]/)) {
        // If the first character is a number, restrict to only numbers
        value = value.replace(/[^0-9]/g, '');
      } else {
        // If the first character is a letter, ensure the first 6 are letters and the rest are numbers
        value = value.toUpperCase(); // Convert to uppercase
        let letters = value.substring(0, 5).replace(/[^A-Z]/g, ''); // First 6 letters
        let numbers = value.substring(5).replace(/[^0-9]/g, ''); // Remaining numbers

        value = letters + numbers;
      }

      if (value.substring(0, 1).match(/[0-9]/)) {
        value = value.substring(0, maxPattern2Length);
      } else {
        value = value.substring(0, maxPattern1Length);
      }

      if (value.substring(0, 1).match(/[0-9]/)) {
        value = value.replace(/(\d{3})(\d{0,1})(\d{0,1})(\d{0,4})(\d{0,4})/, function (_, p1, p2, p3, p4, p5) {
          let result = p1;
          if (p2) result += '-' + p2;
          if (p3) result += '-' + p3;
          if (p4) result += '-' + p4;
          if (p5) result += '-' + p5;
          return result;
        });
      }  else {
        if (!value.substring(0, 1).match(/[0-9]/)) {
          value = value.toUpperCase();
        }
        value = value.replace(/(.{2})(.{0,3})(.{0,3})(.{0,4})/, function (_, p1, p2, p3, p4) {
          let result = p1;
          if (p2) result += '-' + p2;
          if (p3) result += '-' + p3;
          if (p4) result += '-' + p4;
          return result;
        });
      }

      this.invoice.purchaseOrder = value;
    },
    async getProd() {
      try {
        let res = await this.$api.get("/auth/products");
        if (res.status.toString() === "200") {
          this.products = res.data
        }
      } catch (error) {
        console.log("can't get products data")
      }
    },
    async getProv() {
      try {
        let res = await this.$api.get("/auth/providers");
        if (res.status.toString() === "200") {
          this.providers = res.data
        }
      } catch (error) {
        console.log("can't get obj data")
      }
    },
    async getLocation() {
      try {
        let res = await this.$api.get("/auth/inventory/locations");
        if (res.status.toString() === "200") {
          this.locations = res.data
        }
      } catch (error) {
        console.log("can't get location data")
      }
    },
    fireWarning(title, warning) {
      this.$swal.fire({
        icon: 'error',
        title: title,
        text: warning,
        customClass: {
          popup: 'mySwal'
        }
      });
    },
    addRow() {
      let provExpiry = this.invoiceDetail.expires.length > 0 ? this.invoiceDetail.expires + "T01:01:01-06:00" : "0000-01-01T01:01:01-06:00"
      if (this.invoiceDetails.some(item => {
        const isDuplicate =
            String(item.product) === String(this.invoiceDetail.product) &&
            String(item.barcode) === String(this.invoiceDetail.barcode) &&
            String(item.itemBatch) === String(this.invoiceDetail.itemBatch) &&
            String(item.expires) === String(provExpiry)

        console.log('Checking item:', item, 'with invoiceDetail:', this.invoiceDetail, 'and provExpiry:', provExpiry, '=>', isDuplicate);
        console.log('product: ', String(item.product) === String(this.invoiceDetail.product))
        console.log('barcode: ', String(item.barcode) === String(this.invoiceDetail.barcode))
        console.log('itemBatch: ', String(item.itemBatch) === String(this.invoiceDetail.itemBatch))
        console.log('expires: ', String(item.expires) === String(provExpiry))
        return isDuplicate;
      })) {
        this.$swal.fire({
          icon: 'error',
          title: 'Articulo duplicado',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        });
        return;
      }

      if (this.invoiceDetail.product === 0) {
        this.fireWarning('Error', 'Producto ingresado invalido')
        return
      }
      if (this.invoiceDetail.quantity < 1) {
        this.fireWarning('Error', 'Verifique la cantidad del producto')
        return
      }
      if (this.invoiceDetail.unitCost < 0) {
        this.fireWarning('Error', 'Precio unitario ingresado invalido')
        return
      }
      if (this.invoiceDetail.taxesPercentage < 0 || this.invoiceDetail.taxesPercentage > 100) {
        this.fireWarning('Error', 'Porcentaje de ISV ingresado invalido')
        return
      }

      if (this.invoiceDetail.unitCost === "") {
        this.invoiceDetail.unitCost = 0
      }

      if (this.invoiceDetail.taxesPercentage === "") {
        this.invoiceDetail.taxesPercentage = 0
      }

      if (this.invoiceDetail.quantity === "") {
        this.invoiceDetail.quantity = 0
      }

      this.invoiceDetails.push({
        product: this.invoiceDetail.product,
        quantity: this.invoiceDetail.quantity,
        unitCost: this.invoiceDetail.unitCost,
        grossCost: this.invoiceDetail.grossCost,
        netCost: this.invoiceDetail.netCost,
        taxes: this.invoiceDetail.taxes,
        taxesPercentage: this.invoiceDetail.taxesPercentage,
        itemBatch: this.invoiceDetail.itemBatch,
        barcode: this.invoiceDetail.barcode,
        expires: this.invoiceDetail.expires.length > 0 ? this.invoiceDetail.expires + "T01:01:01-06:00" : "0000-01-01T01:01:01-06:00",
      })

      this.invoice.grossCost += this.invoiceDetail.grossCost;
      this.invoice.taxes += this.invoiceDetail.taxes;
      this.invoice.netCost += this.invoiceDetail.netCost;

      this.selectedProductName = ''
      this.invoiceDetail = {
        product: '',
        quantity: 0,
        unitCost: 0,
        grossCost: 0,
        netCost: 0,
        taxes: 0,
        taxesPercentage: 0,
        itemBatch: '',
        barcode: '',
        expires: ''
      }
    },
    async regInvoice() {
      if (this.invoice.provider === 0) {
        this.fireWarning('Error', 'Proveedor ingresado invalido')
        return
      }
      if (this.invoice.code.length < 19) {
        this.fireWarning('Error', 'Numero de factura incompleto')
        return
      }
      if (this.invoice.f01.length < 5) {
        this.fireWarning('Error', 'F01 incompleto')
        return
      }
      if (!(this.invoice.purchaseOrder.length === 15 || this.invoice.purchaseOrder.length === 17)) {
        this.fireWarning('Error', 'Orden de compra incompleta')
        return
      }
      if (this.invoice.invoiceDate.length < 3) {
        this.fireWarning('Error', 'Fecha incorrecta')
        return
      }
      if (this.invoice.location === 0) {
        this.fireWarning('Error', 'Ubicacion invalida')
        return
      }
      if (this.invoiceDetails.length < 1) {
        this.fireWarning('Error', 'No se ha agregado ningun producto')
        return
      }

      const result = await this.$swal.fire({
        title: "Esta seguro que desea continuar?",
        text: "Una vez registrado no se podran realizar cambios. Asegurese de haber revisado con detalle los datos.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: this.$gobBlue,
        cancelButtonColor: this.$gobGolden,
        confirmButtonText: "Si, continuar",
        cancelButtonText: "Cancelar"
      });

      if (result.isConfirmed) {
        try {

          this.invoice.invoiceDate = this.invoice.invoiceDate.length > 0 ? this.invoice.invoiceDate + "T01:01:01-06:00" : "0000-01-01T01:01:01-06:00";

          let formData = new FormData();

          let invoiceC = {...this.invoice}
          let invoiceJson = JSON.stringify(invoiceC);
          formData.append('invoice', invoiceJson)

          let invoiceDetailsC = {...this.invoiceDetails}
          let invoiceDetailsA = Object.values(invoiceDetailsC)
          let invoiceDetailsJson = JSON.stringify(invoiceDetailsA)
          formData.append('invoiceDetails', invoiceDetailsJson)

          let res = await this.$api.post("/auth/invoices", formData);
          if (res.status.toString() !== "200") {
            this.$swal.fire({
              icon: 'success',
              title: 'Se han guardado los cambios',
              text: '',
              customClass: {
                popup: 'mySwal'
              }
            }).then((result) => {
              if (result.isConfirmed) {
                this.invoice = {
                  id: 0,
                  usr: 0,
                  provider: '',
                  code: '',
                  grossCost: 0,
                  taxes: 0,
                  netCost: 0,
                  createdAt: "0000-01-01T01:01:01-06:00",
                  f01: '',
                  invoiceDate: '',
                  purchaseOrder: '',
                  location: 0
                }
                this.selectedProviderName = ''
                this.selectedProductName = ''
                this.selectedLocationName = ''
                this.invoiceDetails = []

                this.$router.push({name: 'ShowInvoice', params: {id: res.data}})
              }
            });
          }
        } catch (error) {
          this.$swal.fire({
            icon: 'error',
            title: '',
            text: 'No se ha podido registrar la factura',
            customClass: {
              popup: 'mySwal'
            }
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.push({name: 'ManageProductInvoice'})
            }
          });
          this.invoiceDetails = []
          this.invoice.invoiceDate = ''
        }
      }
    },
    getIDProvider() {
      let selectedItem = this.providers.find(pro => pro.name.trim() === this.selectedProviderName.trim());
      if (selectedItem !== undefined) {
        this.invoice.provider = selectedItem.id
      } else {
        this.invoice.provider = 0
      }
    },
    getIDLocation() {
      let selectedItem = this.locations.find(loc => loc.name.trim() === this.selectedLocationName.trim());
      if (selectedItem !== undefined) {
        this.invoice.location = selectedItem.id
      } else {
        this.invoice.location = 0
      }
    },
    getIDProduct() {
      let selectedItem = this.products.find(product => product.title.trim() === this.selectedProductName.trim());
      if (selectedItem !== undefined) {
        this.invoiceDetail.product = selectedItem.id
      } else {
        this.invoiceDetail.product = 0
      }
    },
    productDetailCost() {
      this.invoiceDetail.grossCost = parseFloat((this.invoiceDetail.unitCost * this.invoiceDetail.quantity).toFixed(2));
      this.invoiceDetail.taxes = parseFloat(((this.invoiceDetail.taxesPercentage / 100) * this.invoiceDetail.grossCost).toFixed(2));
      this.invoiceDetail.netCost = parseFloat((this.invoiceDetail.grossCost + this.invoiceDetail.taxes).toFixed(2));
    },
    getProductById(id) {
      return this.products.find(prod => prod.id === id) || {};
    },
    deleteProduct(index) {
      this.invoice.grossCost -= this.invoiceDetails[index].grossCost;
      this.invoice.taxes -= this.invoiceDetails[index].taxes;
      this.invoice.netCost -= this.invoiceDetails[index].netCost;

      this.invoiceDetails.splice(index, 1)
    },
    inputLimiterProvider() {
      this.selectedProviderName = this.selectedProviderName.replace(/[^a-z0-9 ñáéíóúü,.~\-"']/gi, '').trimStart();
    },
    inputLimiterBarcode() {
      this.invoiceDetail.barcode = this.invoiceDetail.barcode.replace(/[^a-z0-9 ñáéíóúü,.~\-"']/gi, '').trimStart();
    },
    inputLimiterBatch() {
      this.invoiceDetail.itemBatch = this.invoiceDetail.itemBatch.replace(/[^a-z0-9 ñáéíóúü,.~\-"']/gi, '').trimStart();
    },
    inputLimiterLocation() {
      this.selectedLocationName = this.selectedLocationName.replace(/[^a-z0-9 ñáéíóúü,.~\-"']/gi, '').trimStart();
    },

  },
  created() {
    this.getProv()
    this.getProd()
    this.getLocation()
  },
}

</script>

<template>

  <div id="section-0" class="container">


    <div class="form-reg-user">
      <h1>Registrar factura</h1>
      <form class="Form">
        <div class="grid-container">
          <!-- Column 1 -->
          <div>
            <!-- All your form elements for first column go here -->
            <label>Proveedor</label>
            <input list="prov" v-model="selectedProviderName" @input="getIDProvider" v-on:input="inputLimiterProvider">
            <datalist id="prov">
              <option v-for="pro in providers" :key="pro.id" :value="pro.name"></option>
            </datalist>

            <label>F-01</label>
            <input type="text" v-model="invoice.f01" v-maska data-maska="#####" placeholder="00000">

            <label>Subtotal</label>
            <input disabled type="number" step=".01" v-model="invoice.grossCost">

            <label>ISV</label>
            <input disabled type="number" step=".01" v-model="invoice.taxes"
                   placeholder="00.00">

            <label>Ubicación</label>
            <input list="locations" v-model="selectedLocationName" @input="getIDLocation"
                   v-on:input="inputLimiterLocation">
            <datalist id="locations">
              <option v-for="location in locations" :key="location.id" :value="location.name"></option>
            </datalist>
            <!-- more elements... -->
          </div>

          <!-- Column 2 -->
          <div>
            <!-- All your form elements for second column go here -->
            <label>Número de factura</label>
            <input type="text" v-model="invoice.code" v-maska data-maska="###-###-##-########"
                   placeholder="000-000-00-00000000">


            <label>Orden de compra</label>
            <input type="text" v-model="invoice.purchaseOrder" @input="applyMask" ref="purchaseOrderInput"
                   placeholder="CM-SDE-000-0000">


            <label>Fecha</label>
            <input type="date" v-model="invoice.invoiceDate">

            <label>Total</label>
            <input disabled type="number" step=".01" v-model="invoice.netCost"
                   placeholder="00.00">


            <!-- more elements... -->
          </div>
        </div>

        <h2>Detalle de producto</h2>

        <div class="grid-container">
          <!-- Column 1 -->
          <div>
            <!-- All your form elements for first column go here -->
            <label>Producto</label>
            <input list="products" v-model="selectedProductName" @input="getIDProduct">
            <datalist id="products">
              <option v-for="product in products" :key="product.id" :value="product.title"></option>
            </datalist>

            <label>Cantidad</label>
            <input type="number" step="1" placeholder="00" @input="productDetailCost" v-model="invoiceDetail.quantity">

            <label>Porcentaje de ISV</label>
            <input type="number" step="0.01" placeholder="00.00" @input="productDetailCost"
                   v-model="invoiceDetail.taxesPercentage">

            <label>Subtotal</label>
            <input disabled type="number" step="0.01" placeholder="00.00" oninput="" v-model="invoiceDetail.grossCost">

            <label>Código de Barras</label>
            <input type="text" v-model="invoiceDetail.barcode" v-on:input="inputLimiterBarcode">

          </div>

          <!-- Column 2 -->
          <div>
            <!-- All your form elements for second column go here -->
            <label>Precio unitario</label>
            <input type="number" step=".01" @input="productDetailCost" v-model="invoiceDetail.unitCost"
                   placeholder="00.00">

            <label>Fecha de expiración</label>
            <input type="date" v-model="invoiceDetail.expires">

            <label>Impuesto aplicado</label>
            <input disabled type="number" step=".01" v-model="invoiceDetail.taxes"
                   placeholder="00.00">

            <label>Total</label>
            <input disabled type="number" step=".01" v-model="invoiceDetail.netCost"
                   placeholder="00.00">

            <label>Lote</label>
            <input type="text" v-model="invoiceDetail.itemBatch" v-on:input="inputLimiterBatch">

            <!-- more elements... -->
          </div>
        </div>

        <button id="addRow" @click.prevent="addRow">Agregar</button>

        <div class="container mt-4 table-container" v-if="invoiceDetails.length">
          <table id="myTable">
            <thead>
            <tr>
              <th>#</th>
              <th>Producto</th>
              <th>Cantidad</th>
              <th>Precio Unitario</th>
              <th>Subtotal</th>
              <th>Impuestos</th>
              <th>Expira</th>
              <th>Lote</th>
              <th>Codigo de barra</th>
              <th></th>
            </tr>

            </thead>
            <tbody>
            <tr v-for="(product, index) in invoiceDetails" :key="index">
              <th scope="row">{{ index + 1 }}</th>
              <td>{{ getProductById(product.product).title }}</td>
              <td>{{ product.quantity }}</td>
              <td>{{ product.unitCost }}</td>
              <td>{{ product.grossCost }}</td>
              <td>{{ product.taxes }}</td>
              <td>{{ product.expires.substring(0, 4) === "0000" ? '' : product.expires.substring(0, 10) }}</td>
              <td>{{ product.itemBatch }}</td>
              <td>{{ product.barcode }}</td>
              <td class="td_align_center">
                <button class="tableBtn" type="submit" @click.prevent="deleteProduct(index)">Eliminar</button>
              </td>
            </tr>
            </tbody>
          </table>

        </div>

        <div v-else>
          <p class="bordered-p">No se han registrado productos aún</p>
        </div>


        <button type="submit" @click.prevent="regInvoice">Registrar</button>
      </form>
    </div>

  </div>
</template>


<style>
.bordered-p {
  position: relative;
  display: inline-block;
  padding: 10px 0;
}

.bordered-p::before, .bordered-p::after {
  content: "";
  position: absolute;
  width: 200px; /* Adjust this to control the line length */
  height: 2px;
  background: #97989a;
  top: 0;
  bottom: 0;
  margin: auto;
}

.bordered-p::before {
  left: -210px; /* Increment this if you increase the line length */
}

.bordered-p::after {
  right: -210px; /* Increment this if you increase the line length */
}
</style>